import { createFileRoute } from "@tanstack/react-router";
import SaintCostPage from "@/pages/learn/SaintCostPage";
import { saintCost } from "@/pages/learn/learnDataSaintCost";
export const Route = createFileRoute("/learn/saint-tms-cost")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "SAINT® TMS Cost 2026: From $25,000 | Why $9,900 Isn't SAINT",
        },
        {
          name: "description",
          content:
            "SAINT® at Neuro Wellness starts at $25,000 for the full 5-day course. See what's included, insurance and Medicare options, and why lower-cost \"accelerated TMS\" isn't SAINT®.",
        },
        {
          property: "og:title",
          content:
            "SAINT® TMS Cost 2026: From $25,000 | Why $9,900 Isn't SAINT",
        },
        {
          property: "og:description",
          content:
            "SAINT® at Neuro Wellness starts at $25,000 for the full 5-day course. See what's included, insurance and Medicare options, and why lower-cost \"accelerated TMS\" isn't SAINT®.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/learn/saint-tms-cost",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn/saint-tms-cost",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(saintCost.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintCostPage />;
}
